import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { noDataFound } from "../../../CommonMethhods/CommonMethods";
import AnalyticsStockModal from "./AnalyticsStockModal";
import { useClientStockContext } from "./context/ClientStockContext";

function AnalyticSector(props) {
  const sector = props.sector;
  const [per, setPer] = useState();
  const { handleSectorClick } = useClientStockContext();

  const data = () => {
    const perArr = [];
    sector &&
      sector.map((item) => {
        perArr.push({
          name: item.sec,
          y: item.per,
        });
      });
    setPer(perArr);
  };
  useEffect(() => {
    data();
  }, [sector]);

  const DonutSector = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 320,
      width: 320,
      plotAreaWidth: 700,
      plotAreaHeight: 500,
      type: "pie",
    },
    title: {
      text: "Sectors",
      align: "center",
      verticalAlign: "middle",
      y: 20, // for title top margin
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },
    legend: {
      enabled: false,
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        point: {
          events: {
            click: function () {
              handleSectorClick();
            },
          },
        },
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
        showInLegend: true,
      },
    },
    series: [
      {
        // name: "",
        size: "100%",
        innerSize: "50%",
        dataLabels: {
          formatter: function () {
            // display only if larger than 1
            return this.y > 1
              ? "<b>" + this.point.name + ":</b> " + this.y + "%"
              : null;
          },
        },
        data: per ? per : [],
      },
    ],

    colors: [
      "#feda7c",
      "#61CFF2",
      "#886CC0",
      "#0DBF8D",
      "#FF6161",
      "#FF8952",
      "#eeb5fa",
      " #FF86B1",
      "#1C74D0",
      "rgb(121, 52, 104)",
      "rgb(200, 62, 112)",
    ],
  };

  // function hii(item,key) {
  //   let HoverState=document.querySelector(`.highcharts-point.highcharts-color-${key}`)
  //   HoverState.focus()

  // }

  const showSectorData = () => {
    return (
      sector &&
      sector.map((item, key) => {
        return (
          <tr
            key={key}
            // onMouseEnter={()=>hii(item,key)}
          >
            <td>
              <span className="color-indicator"></span>

              <div className="ml-3">
                {item.sec === undefined || null ? "-" : item.sec}
              </div>
            </td>
            <td>
              <span className="font_color_analytics">
                {item.per === undefined || null ? "-" : item.per.toFixed(2)}%
              </span>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      <div className="analytic-sector">
      {/* <img src={analyticsSectors} alt="" /> */}
        {sector && sector ? (
          <>
            <HighchartsReact highcharts={Highcharts} options={DonutSector} />
            <div className="analyticSector__table">
              <table className="table">
                <tbody className="analytic_Sector_Inner">
                  {showSectorData()}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          noDataFound()
        )}
      </div>

      <AnalyticsStockModal />
    </>
  );
}

export default AnalyticSector;
